export enum EVotetp {
    ADVI = 'ADVI',
    BNDG = 'BNDG'
}
